import React from 'react';
import useReveal from '../hooks/useReveal';

/**
 * SignatureHero — sits directly under the video hero on the homepage.
 * This is the brand's signature image (timber half / bouclé half split bedroom)
 * and acts as the visual "thesis statement" for the entire collection.
 */
const SignatureHero = () => {
  const [ref, visible] = useReveal();
  return (
    <section className="bg-[#F5EDDD] py-20 md:py-28" data-testid="signature-hero">
      <div ref={ref} className={`reveal ${visible ? 'in' : ''} max-w-[1440px] mx-auto px-6 lg:px-10`}>
        <div className="text-center mb-10">
          <p className="text-[11px] tracking-[0.32em] uppercase text-[#A07A4F] mb-4">— Two materials, one philosophy</p>
          <h2
            className="text-4xl md:text-5xl lg:text-6xl text-[#33200F] leading-[1.05]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Where timber meets <span className="italic text-[#5B3A24]">thread.</span>
          </h2>
        </div>
        <div className="relative overflow-hidden bg-[#EDE3CF]">
          <img
            src="/signature-split.jpeg"
            alt="Timber & Thread Co. — solid walnut on one side, ivory bouclé on the other"
            className="w-full h-auto block image-zoom"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default SignatureHero;
